<template>
    <div class="row">
        <div class="col-12 col-sm-4">
            <div class="form-group">
                <MaterialInput
                    :readonly="readonlyForm"
                    :disabled="readonlyForm"
                    class="city-form-group city-bg"
                    id="input-number"
                    name="number"
                    v-model.trim="form.number"
                    v-validate="''"
                    :data-vv-scope="vScope">
                    {{ $t(`${modelTranslateID}.number`) }}
                </MaterialInput>
            </div>
        </div>
        <div class="col-12 col-sm-8">
            <div class="form-group">
                <MaterialSelect
                    :disabled="readonlyForm"
                    class="city-form-group city-bg"
                    id="input-sector_type"
                    name="sector_type"
                    label="name"
                    v-model.trim="form.sector_type_id"
                    :options="types"
                    v-validate="''"
                    :data-vv-scope="vScope"
                    :inputClasses="[{'is-invalid': fnHasError('sector_type', vScope)}]"
                    :error="fnFirstError('sector_type', vScope)">
                    {{ $t(`${modelTranslateID}.sector_type`) }}
                </MaterialSelect>
            </div>
        </div>
    </div>
</template>

<script>
import SearchFormMixin from "../mixins/SearchFormMixin";

export default {
    mixins: [
        SearchFormMixin,
    ],
    computed: {
        types() {
            return this.lists?.types ?? [];
        },
    },
}
</script>